(function () {
  "use strict";

  // メニューページ以外では何もしない
  if (!window.location.pathname.includes("/pages/menu")) {
    return;
  }

  // トップページのHTMLを取得して、メニューセクションを同期
  fetch("/")
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // トップページからmenuHotとmenuDrinkのセクションを取得して同期
      syncMenuSection(doc, "menuHot");
      syncMenuSection(doc, "menuDrink");
    })
    .catch((err) => {
      console.error("メニュー同期エラー:", err);
    });

  function syncMenuSection(sourceDoc, sectionType) {
    // トップページから該当セクションのmenuItems部分を取得
    const sourceSection = sourceDoc.querySelector(
      `[class*="${sectionType}"] .menuItems`,
    );
    if (!sourceSection) {
      console.warn(`トップページに ${sectionType} が見つかりません`);
      return;
    }

    // 現在のページの該当セクションを探す
    const targetSection = document.querySelector(
      `[class*="${sectionType}"] .menuItems`,
    );
    if (!targetSection) {
      console.warn(`メニューページに ${sectionType} が見つかりません`);
      return;
    }

    // 内容を置き換え
    targetSection.innerHTML = sourceSection.innerHTML;
  }
})();
